var map = {
	"./add-existing-registry-banner.gif": 1546,
	"./addexistingregistry_379x180_v2.jpg": 635,
	"./addexistingregistry_548x260.jpg": 1547,
	"./computer.png": 517,
	"./computer@2x.png": 1548,
	"./event.png": 211,
	"./event@2x.png": 1549,
	"./faq.png": 1550,
	"./faq@2x.png": 1551,
	"./home.png": 1552,
	"./home@2x.png": 1553,
	"./photo.png": 1554,
	"./photo@2x.png": 1555,
	"./poi.png": 1556,
	"./poi@2x.png": 1557,
	"./registry-video.jpg": 1558,
	"./registry-video@2x.jpg": 1559,
	"./registry.png": 1560,
	"./registry@2x.png": 1561,
	"./registryconversion_zolaintegration.jpg": 1562,
	"./registryconversion_zolaintegration@2x.jpg": 1563,
	"./rsvp.png": 1564,
	"./rsvp@2x.png": 1565,
	"./travel.png": 1566,
	"./travel@2x.png": 1567,
	"./wedding_party.png": 1568,
	"./wedding_party@2x.png": 1569
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1545;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 1545
// module chunks = 50